<script type="text/javascript">

	import "../LayerList/LayerList.scss";
	import "./AlertFilters.scss";

	import AlertType from "../../Alerts/AlertType";
	import AlertsStore from "../../Alerts/Store";
	import FilterHelper from "../../Helpers/FilterHelper";

	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";

	import LoadState from "../../Enums/LoadState";

	import FiltersComponent from "../../Filters/FiltersComponent.svelte";

	import MenuItem from "../FlyoutMenu/MenuItem.svelte";

	import Feature from "../../Branding/Feature";
	import User from "../../Branding/User";
	import FiltersButtonMenu from "../../Filters/FiltersButtonMenu.svelte";
	import AlertTypeFilterSwitch from "./AlertTypeFilterSwitch.svelte";

	let vessels = AlertsStore.vesselGroup.vessels;
	let loadState = AlertsStore.meta.loadState;
	let alertsLastUpdated = AlertsStore.meta.lastUpdated;

	let filters = AlertsStore.filters.advanced;
	let filtersLastUpdated = AlertsStore.filters.lastUpdated;
	let advancedFiltersUpdated = filters.lastUpdated;

	let vesselTypeOptions = [];
	let flagOptions = [];
	let destinationOptions = [];
	$: {
		$alertsLastUpdated;

		// We need to build the enum options for the filters. Use the global dataset for this.
		// vesselTypeOptions = $vessels.map((vessel) => { return vessel.classification; }).filter(FilterHelper.unique).sort();
		// flagOptions = $vessels.map((vessel) => { return vessel.flag; }).filter(FilterHelper.unique).sort();
		// destinationOptions = $vessels.map((vessel) => { return vessel.voyageDestination; }).filter(FilterHelper.unique).sort();

		// We need to build the enum options for the filters. Use the dataset reduced after Alert Types toggles for this.
		vesselTypeOptions = [];
		flagOptions = [];
		destinationOptions = [];

		$vessels.forEach((vessel) => {
			for(let i = 0; i < vessel.alertTypes.length; i++) {
				if (AlertsStore.helpers.isAlertTypeVisible(vessel.alertTypes[i])) {
					vesselTypeOptions.push(vessel.classification);
					flagOptions.push(vessel.flag);
					destinationOptions.push(vessel.voyageDestination);
					break;
				}
			}
		});
		vesselTypeOptions = vesselTypeOptions.filter(FilterHelper.unique).sort();
		flagOptions = flagOptions.filter(FilterHelper.unique).sort();
		destinationOptions = destinationOptions.filter(FilterHelper.unique).sort();

		filters.setPropertyEnumOptions("classification", vesselTypeOptions);
		filters.setPropertyEnumOptions("flag", flagOptions);
		filters.setPropertyEnumOptions("voyageDestination", destinationOptions);
	}

	$: {
		$filtersLastUpdated = $advancedFiltersUpdated;
		filters = filters;

		AlertsStore.filters.lastUpdated.set(new Date());
		AlertsStore.actions.updateMapSources();
	}

	let layerChange = (event) => {
		const targetData = event.target.parentNode.parentNode.parentNode;
		const targetCheckbox = event.target;

		const type = targetData.dataset.alerttype;
		const checked = targetCheckbox.checked;
		// console.log("type", type, "checked", checked);
		AlertsStore.actions.setAlertTypeVisible(type, checked);
	};
	let sublayerChange = (event) => {
		const targetData = event.target.parentNode.parentNode.parentNode;
		const targetCheckbox = event.target;

		const type = targetData.dataset.alerttype;
		const subcategory = targetData.dataset.subcategory;
		const checked = targetCheckbox.checked;

		// console.log("sublayerChange", event);
		// console.log("type", type, "subcategory", subcategory, "checked", checked);
		AlertsStore.actions.setAlertTypeSubcategoryVisible(type, subcategory, checked);
	};

	let fixedAlertsOrder = [
		AlertType.MYF,
		AlertType.COF,
		AlertType.RIM,
		AlertType.ERI,
		AlertType.LRI,
		AlertType.PCS,
		AlertType.LPO,
		AlertType.ETW,
		AlertType.LTW,
		AlertType.EEZ,
		AlertType.LEZ,
		AlertType.O22H,
		AlertType.O1D,
		AlertType.O2D,
		AlertType.O7D,
		AlertType.ABO,
		AlertType.CAS,
		AlertType.DEC,
		AlertType.STS,
		AlertType.NBY
	];

</script>

<MenuItem materialIcon={"layers"} title={"Alert Filters"} class="layer-list-component filters-component">
	<div slot="context-menu">
		{#if User.hasFeature(Feature.ALERTS.FILTER)}
			<FiltersButtonMenu filters={filters} hackStyle={"left:-152px;"}/>
		{/if}
	</div>

	{#each fixedAlertsOrder as alertType}
		{#if User.hasAlertType(alertType)}
			<AlertTypeFilterSwitch
				alertType={alertType}
				filterData={AlertsStore.filters.alertTypes[alertType]}
				onMainToggle={layerChange}
				onSubToggle={sublayerChange}
				/>
		{/if}
	{/each}

	{#if User.hasFeature(Feature.ALERTS.FILTER)}
		<div class="content">
			{#if $loadState != LoadState.LOADED}
				<p style="text-align:center;margin:0px;overflow:auto;height:48px;">
					<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
				</p>
			{:else}
				<FiltersComponent name="alerts" filters={filters} />
			{/if}
		</div>
	{/if}
</MenuItem>
